<template>
    <v-form ref="form" lazy-validation :disabled="loading" @submit.prevent="upload()">
        <v-text-field outlined label="Paste URL here" type="url" v-model="url" :rules="urlRules" required>
            <template v-slot:append>
                <div class="mt-n2">
                    <v-btn v-if="success" color="success" text><v-icon>mdi-check</v-icon></v-btn>
                    <v-btn v-else @click="upload()" :loading="loading" text color="primary">Upload</v-btn>
                </div>
            </template>
        </v-text-field>

        <v-alert v-if="error" text type="error" class="mt-4">{{ error }}</v-alert>
        <v-alert v-if="nameCollisions.length" type="info" class="mt-4" text>
            The following files were renamed because of name collisions:
            <ul>
                <li v-for="collision in nameCollisions" :key="collision.originalName">{{ collision.originalName }} -> {{ collision.finalName }}</li>
            </ul>
        </v-alert>
    </v-form>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import isURL from 'validator/es/lib/isURL'
import { fetchTask } from '@/apis'

export default {
    name: 'UrlUpload',
    props: {
        reset: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            loading: false,
            url: '',
            urlRules: [v => !!v || 'URL is required', v => (v && isURL(v)) || 'Must be a valid URL'],
            error: '',
            success: false,
            nameCollisions: []
        }
    },
    methods: {
        async upload() {
            if (!this.$refs.form.validate()) return
            try {
                this.loading = true
                this.$emit('uploading', 'uploading')

                const { data } = await this.$axios.post(`files/${this.$route.params.snid}/download_url`, {
                    url: this.url,
                    area: this.fileAreaType,
                    local_path: this.currentFileLocalPath || '',
                    operation: 'CREATE'
                })
                const taskResult = await fetchTask(data.tkid)
                if (taskResult instanceof Error) {
                    this.$emit('uploading', 'error')
                    this.error = taskResult.message
                } else {
                    console.log('taskResult:', taskResult)
                    // taskResult.successful.forEach(file => {
                    //     const response = file.response.body
                    //     if (response.collision_info && response.collision_info.was_renamed) {
                    //         this.nameCollisions.push({
                    //             originalName: response.collision_info.original_name,
                    //             finalName: response.collision_info.final_name
                    //         })
                    //     }
                    // })
                    this.$emit('uploading', 'success')
                    this.success = true
                }
            } catch (error) {
                this.$emit('uploading', 'error')
                this.error = 'File upload failed due to network issues.'
            } finally {
                this.loading = false
            }
        }
    },
    computed: {
        ...mapState('snapshotStore', ['fileAreaType']),
        ...mapGetters('snapshotStore', ['currentFileLocalPath'])
    },
    watch: {
        reset(need) {
            if (!need) return
            this.$refs.form.reset()
            this.loading = false
            this.url = ''
            this.error = ''
            this.success = false
        }
    }
}
</script>
